export default "__VITE_ASSET__B3HQMU2h__"